import { headers, baseUrl } from "../../common/credentials";

const Port = "1200"; // Your Django server port

// ── Auth ──────────────────────────────────────────────────────────────────────

export const FinanceIQLogin = () => {
    let url = baseUrl + Port + "/api/auth/login/";
    return ([headers, url]);
};

export const FinanceIQMe = () => {
    let url = baseUrl + Port + "/api/auth/me/";
    return ([headers, url]);
};

// ── Session ───────────────────────────────────────────────────────────────────

export const FinanceIQCreateSession = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/chat/session/";
    return ([headers, url]);
};

// ── Conversation ──────────────────────────────────────────────────────────────

export const FinanceIQCreateConversation = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/chat/conversation/";
    return ([headers, url]);
};

export const FinanceIQGetHistory = (conv_id) => {
    let url = baseUrl + Port + `/api/v2/user_modules/api/chat/history/${conv_id}/`;
    return ([headers, url]);
};

// ── Metadata ──────────────────────────────────────────────────────────────────

export const FinanceIQEntities = (entityId) => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/metadata/entities/";
    if (entityId) {
        url += `?entity_id=${encodeURIComponent(entityId)}`;
    }
    return ([headers, url]);
};

// ── Health ────────────────────────────────────────────────────────────────────

export const FinanceIQHealth = () => {
    let url = baseUrl + Port + "/api/v2/user_modules/api/chat/health/";
    return ([headers, url]);
};

// ── Stream (SSE) ──────────────────────────────────────────────────────────────
// SSE cannot go through axios — returns just the URL and uses fetch internally.
// The token is passed explicitly from sessionStorage.

export const FinanceIQStreamUrl = () => {
    return baseUrl + Port + "/api/v2/user_modules/api/chat/stream/";
};
